import { Button, Form, Modal } from "antd";
import { useForm } from "antd/es/form/Form";
import { UI_ITONumericInput } from "../../../../UI_ITO/UI_ITONumericInput/UI_ITONumericInput";
import classes from "./AttachPersonToManager.module.css";
import { IAttachPersonToManagerProps } from "../../../../interfaces/props/AdminManagerInfo/IAttachPersonToManagerProps";
import {
  ruleInn,
  ruleRequired,
} from "../../../../constants/rules/RulesConstantsForms";

export const AttachPersonToManager = ({
  formProps,
  modalProps,
  cancelReconnectButtonProps,
  reattachButtonProps,
  personConnectManagerName,
  attachButtonProps,
}: IAttachPersonToManagerProps) => {
  const [form] = useForm();

  const concatFormClassName = `${classes.form} ${formProps?.className || ""}`;
  return (
    <>
      <Form
        {...formProps}
        name="assignClientsInfoForm"
        form={form}
        layout="vertical"
        autoComplete="off"
        className={concatFormClassName}
      >
        <h2 className={classes.title}>Закрепить клиента / агента</h2>

        <div className={classes.formItemInn}>
          <Form.Item
            name="inn"
            rules={[ruleInn, ruleRequired]}
            className={classes.assignClientsInput}
          >
            <UI_ITONumericInput
              className={classes.innInput}
              color="default"
              placeholder="Введите ИНН"
              size="large"
              maxLength={12}
            />
          </Form.Item>

          <Button
            htmlType="submit"
            variant="solid"
            color="primary"
            className={classes.addClientButton}
            {...attachButtonProps}
          >
            Закрепить
          </Button>
        </div>
      </Form>
      <Modal
        {...modalProps}
        footer={
          <div className={classes.footer}>
            <Button
              {...reattachButtonProps}
              size="middle"
              key="submit"
              color={"primary"}
              variant="solid"
            >
              Перезакрепить
            </Button>
            <Button
              {...cancelReconnectButtonProps}
              color="danger"
              variant="outlined"
              size="middle"
              key="back"
              className={classes.cancelModalBtn}
            >
              Отменить
            </Button>
          </div>
        }
      >
        {personConnectManagerName && (
          <div className={classes.descriptionText}>
            Клиент/агент уже закреплен за менеджером:
            <p className={classes.managerName}>{personConnectManagerName}</p>
          </div>
        )}
      </Modal>
    </>
  );
};
